import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import type { DevToolsPlugin } from '../../types';
import { styles } from './auth-session.styles';

@customElement('acme-devtools-auth-session')
export class AcmeDevToolsAuthSession extends LitElement {
  static override styles = styles;

  override connectedCallback(): void {
    super.connectedCallback();
    this.requestUpdate();
  }

  override render() {
    const user = window.__ACME_B2B__?.devTools?.getUserFromCookie?.() ?? null;
    const csr = window.__ACME_B2B__?.devTools?.getCSRUserFromCookie?.() ?? null;

    return html`
      ${csr
        ? html`<div class="impersonation-banner">
            CSR Impersonating as ${csr.firstName} ${csr.lastName} (${csr.email})
          </div>`
        : nothing}
      ${!user
        ? html`<div class="empty">Not logged in — no session cookie found.</div>`
        : html`
            <h3 class="section-heading">User Identity</h3>
            ${this._row('ID', String(user.id))} ${this._row('Name', `${user.firstName} ${user.lastName}`)}
            ${user.userName ? this._row('Username', user.userName) : nothing} ${this._row('Email', user.email)}
            ${this._row('Company', user.companyName)} ${this._row('MID', user.mid)}
            ${this._row('Tenant ID', String(user.tenantId))} ${this._row('Auth type', user.authenticationType)}
            <div class="row">
              <span class="row-label">Roles</span>
              <div class="roles">${user.roles.map((r) => html`<span class="role-badge">${r}</span>`)}</div>
            </div>

            ${user.passwordStatus ? this._row('Password status', user.passwordStatus) : nothing}
            ${user.passwordDaysRemaining != null
              ? this._row('Password days left', String(user.passwordDaysRemaining))
              : nothing}
          `}
    `;
  }

  private _row(label: string, value: string) {
    return html`
      <div class="row">
        <span class="row-label">${label}</span>
        <span class="row-value">${value}</span>
      </div>
    `;
  }
}

export const authSessionPlugin: DevToolsPlugin = {
  id: 'auth-session',
  label: 'Auth',
  tagName: 'acme-devtools-auth-session',
};

declare global {
  interface HTMLElementTagNameMap {
    'acme-devtools-auth-session': AcmeDevToolsAuthSession;
  }
}
